export const COBRO_ACCESORIOS_TYPE = {
    PRIORIDAD_PAGO_ACCESORIOS: 770,
    DISTRIBUCION_CRONOLOGICA: 771,
    DISTRIBUCION_PROPORCIONAL: 772
}
